import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=03d4dde3&scoped=true"
import script from "./copy_right.js?vue&type=script&lang=js&external"
export * from "./copy_right.js?vue&type=script&lang=js&external"
import style0 from "./copy_right.scss?vue&type=style&index=0&id=03d4dde3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d4dde3",
  null
  
)

export default component.exports